<div class="flex justify-center form-container">
  <div class="w-343 tablet:w-720 laptop:w-912 mobile:mx-5 tablet:mx-6 laptop:mx-0">
    <div
      *ngIf="!referee || referee.status === RefereeStatus.AwaitingDetails">
    </div>
    <button id="backbutton" class="cancel w-44 h-44"  (click)="backToRefereelist()">
      <i class="fak fa-talos-arrow-right left-arrow"></i>
    </button>
    <div class="pt-7 pr-4">
      <h1 class="name mb-2" *ngIf="!isEditForm">Referee</h1>
      <div *ngIf="referee">
        <div class="edit-warning flex items-center w-343 tablet:w-720 laptop:w-912 mt-5 mb-8 px-5 py-4" *ngIf="isEditForm">
          <i class="fak fa-information text-info-100 text-7"></i>
          <p class="text-3">Please note, changing and submitting this form again will resend the reference request.</p>
        </div>
        <h1 class="name mb-2" *ngIf="isEditForm">{{referee.firstName}} {{referee.lastName}}</h1>
        <div class="flex items-center pb-9 mb-9 border-b-1 border-neutral-100">
          <p class="text-5 text-neutral-700">Please give details of someone who can provide a <span class="font-medium text-5 text-neutral-700">{{referenceTypes[referee.referenceType]}} reference</span> on your behalf</p>
          <button class="tooltip-subject tooltip-manual-reference reference-info flex self-center" type="button" *ngIf="referee.referenceType === 0">
            <i class="fak fa-information text-neutral-500 text-7"></i>
            <div class="tooltip w-310 bottom-8 left-MINUS143">
              <div class="tooltip-content text-left text-3 leading-20">
                A personal reference can be provided by someone who knows you outside of a work environment and can vouch for your character and skills.
              </div>
            </div>
          </button>
          <button class="tooltip-subject tooltip-manual-reference reference-info flex self-center" type="button" *ngIf="referee.referenceType === 1">
            <i class="fak fa-information text-neutral-500 text-7"></i>
            <div class="tooltip w-310 bottom-8 left-MINUS143">
              <div class="tooltip-content text-left text-3 leading-20">
                A professional reference can be supplied from someone who has detailed information on your employment from an organisation where you have worked or are currently working.
              </div>
            </div>
          </button>
        </div>
        <div class="flex">
          <i class="fak fa-talos-user icon"></i>
          <span class="font-medium pb-6 pl-2 text-4 text-dark">Referee Details</span>
        </div>
        <div class="referee-form-grid items-start">
          <div class="col-span-2">
        </div>

      <div class="grid grid-cols-1 tablet:grid-cols-2">
        <div class="mb-8 mr-2 w-343 laptop:w-448">
          <label for="firstName" class="block">Referee first name</label>
          <div class="container">
            <input
              (input)="onRefereeFirstNameChange($event);"
              [value]="referee.firstName"
              name="firstName"
              id="firstName"
              [ngClass]="getFieldShowValidationMessage('firstName') ? 'error border-error-500': 'border-neutral-200'"
              required
              class="w-343 laptop:w-448 block border h-52 p-4 rounded mr-4 input"/>
            <i class="fak fa-talos-warning-triangle text-4"
            [ngClass]="getFieldShowValidationMessage('firstName') ? 'icon-error': 'invisible'"
            ></i>
          </div>
          <div *ngIf="getFieldShowValidationMessage('firstName')" class="text-error-500 text-2 mt-2">
            Please enter a first name
          </div>
        </div>
        <div class="mb-8 ml-0 tablet:ml-5 w-343 laptop:w-448">
          <label for="lastName" class="block">Referee last name</label>
          <div class="container">
            <input
              (input)="onRefereeLastNameChange($event);"
              [value]="referee.lastName"
              name="lastName"
              id="lastName"
              [ngClass]="getFieldShowValidationMessage('lastName') ? 'error border-error-500' : 'border-neutral-200'"
              required
              class="w-343 laptop:w-448 block border h-52 p-4 rounded" />
            <i class="fak fa-talos-warning-triangle text-4"
            [ngClass]="getFieldShowValidationMessage('lastName') ? 'icon-error': 'invisible'"
            ></i>
            </div>
          <div *ngIf="getFieldShowValidationMessage('lastName')" class="text-error-500 text-2 mt-2">
            Please enter a last name
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 tablet:grid-cols-2">
        <div class="pb-8 mr-2 w-343 laptop:w-448">
          <label for="emailAddress" class="block">Referee email address</label>
          <div class="container">
            <input
              (input)="onRefereeEmailChange($event);"
              [value]="referee.emailAddress"
              name="emailAddress"
              id="emailAddress"
              [ngClass]="getFieldShowValidationMessage('emailAddress') ? 'error border-error-500' : 'border-neutral-200'"
              required
              class="w-343 laptop:w-448 block border h-52 p-4 rounded" />
            <i class="fak fa-talos-warning-triangle text-4"
            [ngClass]="getFieldShowValidationMessage('emailAddress') ? 'icon-error': 'invisible'"
            ></i>
            </div>
          <div *ngIf="getFieldShowValidationMessage('emailAddress')" class="text-error-500 text-2 mt-2">
            Please enter a valid email address
          </div>
        </div>
        <div class="pb-8 ml-0 tablet:ml-5 w-343  laptop:w-448">
          <label for="contactNumber" class="block">Referee contact number (optional)</label>
          <input
            (input)="onRefereeContactNumberChange($event);"
            [value]="referee.contactNumber"
            name="contactNumber"
            id="contactNumber"
            class="w-full block border border-neutral-200 h-52 p-4 rounded" />
        </div>
      </div>

        <div class="grid grid-cols-1 tablet:grid-cols-2">
          <div class="mr-2 w-343  laptop:w-448" *ngIf="referee.referenceType === ReferenceTypes.Professional">
            <label for="jobTitle" class="block">Referee's job title at the time</label>
            <div class="container">
              <input
                (input)="onRefereeJobTitleChange($event);"
                [value]="referee.jobTitle"
                name="jobTitle"
                id="jobTitle"
                [ngClass]="getFieldShowValidationMessage('jobTitle') ? 'error border-error-500' : 'border-neutral-200'"
                required
                class="w-343 laptop:w-448 block border h-52 p-4 rounded" />
              <i class="fak fa-talos-warning-triangle text-4"
              [ngClass]="getFieldShowValidationMessage('jobTitle') ? 'icon-error': 'invisible'"
              ></i>
            </div>
            <div *ngIf="getFieldShowValidationMessage('jobTitle')" class="text-error-500 text-2 mt-2">
              Please enter referee's job title at the time
            </div>
          </div>
        </div>
      </div>

      <div class="referee-form-grid items-start"
        *ngIf="referee.referenceType === ReferenceTypes.Professional">
        <div class="col-span-2 flex items-center mt-9 pb-6">
          <i class="fak fa-talos-building icon"></i>
          <div class="font-medium text-4 pl-2 text-dark">Organisation Details</div>
        </div>
        <div class="grid grid-cols-1 tablet:grid-cols-2">
          <div class="pb-8 mr-2 w-343  laptop:w-448">
            <label for="organisationName" class="block">Organisation name</label>
            <div class="container">
              <input
                (input)="onRefereeOrganisationNameChange($event);"
                [value]="referee.organisationName"
                name="organisationName"
                id="organisationName"
                [ngClass]="getFieldShowValidationMessage('organisationName') ? 'error border-error-500' : 'border-neutral-200'"
                required
                class="w-343 laptop:w-448 block border h-52 p-4 rounded" />
              <i class="fak fa-talos-warning-triangle text-4"
              [ngClass]="getFieldShowValidationMessage('firstName') ? 'icon-error': 'invisible'"
              ></i>
            </div>
            <div *ngIf="getFieldShowValidationMessage('organisationName')" class="text-error-500 text-2 mt-2">
              Please enter the organisation name
            </div>
          </div>
          <div class="ml-0 tablet:ml-5 w-343  laptop:w-448">
            <label for="candidatePosition" class="block">Your position at the time</label>
            <div class="container">
              <input
                (input)="onRefereeYourPositionChange($event);"
                [value]="referee.candidatePosition"
                name="candidatePosition"
                id="candidatePosition"
                [ngClass]="getFieldShowValidationMessage('candidatePosition') ? 'error border-error-500' : 'border-neutral-200'"
                required
                class="w-343 laptop:w-448 block border border-neutral-200 h-52 p-4 rounded" />
              <i class="fak fa-talos-warning-triangle text-4"
              [ngClass]="getFieldShowValidationMessage('firstName') ? 'icon-error': 'invisible'"
              ></i>
            </div>
            <div *ngIf="getFieldShowValidationMessage('candidatePosition')" class="text-error-500 text-2 mt-2">
              Please enter your position at the time
            </div>
          </div>

        </div>

        <div class="grid grid-cols-1 tablet:grid-cols-2">

          <div class="mr-2 mt-9 tablet:mt-0 w-343 laptop:w-448">
            <div class="font-medium text-4 mb-5 text-dark">
              Start date
            </div>
            <label for="startDateMonth" class="block">Month</label>
            <div class="container">
              <button
                (click)="toggleStartMonthDropdown($event);"
                name="startDateMonth"
                id="startDateMonth"
                [ngClass]="[
                  getFieldShowValidationMessage('startDateMonth') ? 'border-error-500 button-error' :
                  referee.startDateMonth === null ? 'border-neutral-100' : 'border-neutral-200',
                  shouldShowStartMonthDropdown ? ' active' : ''
                ]"
                required
                class="w-343 laptop:w-448 block h-52 pl-4 dropdown-parent">
                <span class="text-4" [ngClass]="referee.startDateMonth === null ? 'text-neutral-400' : ''">{{monthToString(referee.startDateMonth)}}</span>

                <div
                  *ngIf="shouldShowStartMonthDropdown"
                  (click)="toggleStartMonthDropdown($event);"
                  class="overlay"></div>

                <div
                  *ngIf="shouldShowStartMonthDropdown"
                  class="dropdown right-none w-full overflow-y-scroll max-h-310 m-0 p-2">
                  <button
                    *ngFor="let month of months; let i = index"
                    (click)="toggleStartMonthDropdown($event); onRefereeStartMonthChange(month);"
                    [id]="'start-month-' + i"
                    class="dropdown-button text-left text-4 text-dark-500 py-2 mb-1.25 m-0 h-44"
                    type="button">
                    {{monthToString(month)}}
                  </button>
                </div>
              </button>
              <i class="fak fa-talos-chevron chevron pt-1"
                [ngClass]="getFieldShowValidationMessage('startDateMonth') ? 'text-error-500' : 'text-neutral-400'"
                (click)="toggleStartMonthDropdown($event);"
              ></i>
          </div>
            <div *ngIf="getFieldShowValidationMessage('startDateMonth')" class="text-error-500 text-2 mt-2">
              Please choose a month
            </div>
          </div>
          <div class="ml-0 tablet:ml-5 w-343 laptop:w-448 start-year">
            <div class="font-medium mb-5 invisible tablet:visible">
              &nbsp;
            </div>
            <label for="startDateYear" class="block">Year</label>
            <div class="container">
              <button
                (click)="toggleStartYearDropdown($event);"
                name="startDateYear"
                id="startDateYear"
                [ngClass]="[
                  getFieldShowValidationMessage('startDateYear') ? 'border-error-500 button-error' :
                  referee.startDateYear === null ? 'border-neutral-100' : 'border-neutral-200',
                  shouldShowStartYearDropdown ? ' active' : ''
                ]"
                required
                class="w-343 laptop:w-448 block h-52 pl-4 dropdown-parent">
                <span class="text-4" [ngClass]="referee.startDateYear === null ? 'text-neutral-400' : ''">{{referee.startDateYear || 'Choose your year'}}</span>

                <div
                  *ngIf="shouldShowStartYearDropdown"
                  (click)="toggleStartYearDropdown($event);"
                  class="overlay"></div>

                <div
                  *ngIf="shouldShowStartYearDropdown"
                  class="dropdown right-none w-full overflow-y-scroll max-h-310 p-2 m-0">
                  <button
                    *ngFor="let year of years; let i = index"
                    (click)="toggleStartYearDropdown($event); onRefereeStartYearChange(year);"
                    [id]="'start-year-' + i"
                    class="dropdown-button text-left text-4 text-dark-500 py-2 mb-1.25 m-0 h-44"
                    type="button">
                    {{year}}
                  </button>
                </div>
              </button>
              <i class="fak fa-talos-chevron chevron pt-1"
                [ngClass]="getFieldShowValidationMessage('startDateYear') ? 'text-error-500' : 'text-neutral-400'"
                (click)="toggleStartYearDropdown($event);"
              ></i>
            </div>
            <div *ngIf="getFieldShowValidationMessage('startDateYear')" class="text-error-500 text-2 mt-2">
              Please choose a year
            </div>
          </div>

        </div>


        <div class="grid grid-cols-1 tablet:grid-cols-2">
          <div class="mt-8 mr-2 w-343 laptop:w-448">
            <div class="font-medium text-4 mb-5 text-dark">
              End date
            </div>
            <label for="endDateMonth" class="block mt-6"  [ngClass]="{'grey': isCurrentRole === true}">Month</label>
            <div class="container">
              <input type="text" placeholder="Choose your month" class="disabled-input w-343 laptop:w-448 h-52" disabled *ngIf="referee.currentRole">
              <i class="fak fa-talos-chevron chevron pt-1 text-neutral-400"
              *ngIf="referee.currentRole"
              ></i>
            </div>
            <div class="container">
            <button
              (click)="toggleEndMonthDropdown($event);"
              name="endDateMonth"
              id="endDateMonth"
              [ngClass]="[
                getFieldShowValidationMessage('endDateMonth') ? 'border-error-500 button-error' :
                referee.endDateMonth === null ? 'border-neutral-100' : 'border-neutral-200',
                shouldShowEndMonthDropdown ? ' active' : ''
              ]"
              class="w-343 laptop:w-448 block h-52 pl-4 dropdown-parent" *ngIf="!referee.currentRole">
              <span class="text-4" [ngClass]="referee.endDateMonth === null ? 'text-neutral-400' : ''">{{monthToString(referee.endDateMonth)}}</span>

              <div
                *ngIf="shouldShowEndMonthDropdown"
                (click)="toggleEndMonthDropdown($event);"
                class="overlay"></div>

              <div
                *ngIf="shouldShowEndMonthDropdown"
                class="dropdown right-none top-10 w-full overflow-y-scroll max-h-310 p-2 m-0">
                <button
                  *ngFor="let month of months; let i = index"
                  (click)="toggleEndMonthDropdown($event); onRefereeEndMonthChange(month);"
                  [id]="'end-month-' + i"
                  class="dropdown-button text-left text-4 text-dark-500 py-2 mb-1.25 m-0 h-44"
                  type="button"
                  [disabled] ="this.referee.currentRole"
                  [ngClass]="'disabled'"
                  >
                  {{monthToString(month)}}
                </button>
              </div>
            </button>
            <i class="fak fa-talos-chevron chevron pt-1"
            [ngClass]="getFieldShowValidationMessage('endDateMonth') ? 'text-error-500' : 'text-neutral-400'"
            (click)="toggleEndMonthDropdown($event);"
            *ngIf="!referee.currentRole"
          ></i>
          </div>
            <div *ngIf="getEndDateRequiredMessage('endDateMonth')" class="text-error-500 text-2 mt-2">
              Please choose a month
            </div>
            <div *ngIf="getEndDateValidationMessage('endDateYear')" class="text-error-500 text-2 mt-2">
              The end date must come after the start date
            </div>
          </div>
          <div class="ml-0 tablet:ml-5 w-343 laptop:w-448 end-year">
            <div class="font-medium mb-5 tablet:mb-10 invisible tablet:visible">
              &nbsp;
            </div>
            <label class="block"  [ngClass]="{'grey': isCurrentRole === true}">Year</label>
            <div class="container">
              <input type="text" placeholder="Choose your year" class="disabled-input w-343 laptop:w-448 h-52" disabled *ngIf="referee.currentRole">
              <i class="fak fa-talos-chevron chevron pt-1 text-neutral-400"
              *ngIf="referee.currentRole"
              ></i>
            </div>
            <div class="container">
              <button
                (click)="toggleEndYearDropdown($event);"
                name="endDateYear"
                id="endDateYear"
                [ngClass]="[
                  getFieldShowValidationMessage('endDateYear') ? 'border-error-500 button-error' :
                  referee.endDateYear === null ? 'border-neutral-100' : 'border-neutral-200',
                  shouldShowEndYearDropdown ? ' active' : ''
                ]"
                class="w-343 laptop:w-448 block h-52 pl-4 dropdown-parent" *ngIf="!referee.currentRole">
                <span class="text-4" [ngClass]="referee.endDateYear === null ? 'text-neutral-400' : ''">{{referee.endDateYear || 'Choose your year'}}</span>

                <div
                  *ngIf="shouldShowEndYearDropdown"
                  (click)="toggleEndYearDropdown($event);"
                  class="overlay"></div>

                <div
                  *ngIf="shouldShowEndYearDropdown"
                  class="dropdown right-none top-10 w-full overflow-y-scroll max-h-310 p-2 m-0">
                  <button
                    *ngFor="let year of years; let i = index"
                    (click)="toggleEndYearDropdown($event); onRefereeEndYearChange(year);"
                    [id]="'end-year-' + i"
                    class="dropdown-button text-left text-4 text-dark-500 py-2 mb-1.25 m-0 h-44"
                    type="button"
                    [disabled] ="this.referee.currentRole">
                    {{year}}
                  </button>
                </div>
              </button>
              <i class="fak fa-talos-chevron chevron pt-1"
                [ngClass]="getFieldShowValidationMessage('endDateYear') ? 'text-error-500' : 'text-neutral-400'"
                (click)="toggleEndYearDropdown($event);"
                *ngIf="!referee.currentRole"
              ></i>
          </div>
            <div *ngIf="getEndDateRequiredMessage('endDateYear')" class="text-error-500 text-2 mt-2">
              Please choose a year
            </div>
            <div *ngIf="getEndDateValidationMessage('endDateYear')" class="text-error-500 text-2 mt-2">
              The end date must come after the start date
            </div>
          </div>
        </div>
        <div class="flex mt-4 mb-8">
          <input type="checkbox"
            class="mr-2 check"
            [checked]="referee.currentRole"
            name="currentRole"
            id="currentRole"
            (click)="onRefereeCurrentRoleChange($event);"
            />
          <p class="text-3">Current role</p>
        </div>
          </div>

      <div
          class="grid grid-cols-1 tablet:grid-cols-2 referee-form-grid items-end"
        *ngIf="referee.referenceType === ReferenceTypes.Personal">
        <div class="col-span-2">
          <div class="flex items-center mb-5">
            <i class="fak fa-talos-two-people icon"></i>
            <span class="font-medium pl-2 text-4 text-dark">Relationship Details</span>
          </div>
        </div>

        <div class="pb-8 mr-2">
          <label for="timeKnown" class="block">Time known</label>
          <div class="container">
            <button
              (click)="toggleTimeKnownDropdown($event);"
              name="timeKnown"
              id="timeKnown"
              [ngClass]="[
                getFieldShowValidationMessage('timeKnown') ? 'border-error-500 button-error' :
                referee.timeKnown === null ? 'border-neutral-100' : 'border-neutral-200',
                shouldShowTimeKnownDropdown ? ' active' : ''
              ]"
              class="w-343 laptop:w-448 block h-52 pl-4 dropdown-parent">
              <span class="text-4" [ngClass]="referee.timeKnown === null ? 'text-neutral-400' : ''">{{getTimeKnown(referee.timeKnown)}}</span>

              <div
                *ngIf="shouldShowTimeKnownDropdown"
                (click)="toggleTimeKnownDropdown($event);"
                class="overlay"></div>

              <div
                *ngIf="shouldShowTimeKnownDropdown"
                class="dropdown right-none text-4 top-10 w-full overflow-y-scroll max-h-310">
                <button
                  *ngFor="let tk of timeKnowns; let i = index"
                  (click)="toggleTimeKnownDropdown($event); onRefereeTimeKnownChange(tk);"
                  [id]="'time-known-' + i"
                  class="dropdown-button text-left text-4"
                  type="button">
                  {{getTimeKnown(tk)}}
                </button>
              </div>
            </button>
            <i class="fak fa-talos-chevron chevron pt-1"
              [ngClass]="getFieldShowValidationMessage('endDateYear') ? 'text-error-500' : 'text-neutral-400'"
              (click)="toggleStartYearDropdown($event);"
            ></i>
          </div>
          <div *ngIf="getFieldShowValidationMessage('timeKnown')" class="text-error-500 text-2 mt-2">
            Please choose a date range
          </div>
        </div>
        <div class="col-span-2 mb-7">
          <label for="relationship" class="block">Relationship with this referee</label>
          <textarea
            class="h-100 block rounded w-343 laptop:w-912 text-4"
            name="relationship"
            id="relationship"
            [ngClass]="getFieldShowValidationMessage('relationship') ? 'border-error-500' : 'border-neutral-200'"
            (input)="onRefereeRelationshipChange($event)"
            [value]="referee.relationship">
          </textarea>
          <div *ngIf="getFieldShowValidationMessage('relationship')" class="text-error-500 text-2 mt-2">
            Please enter the relationship with this referee
          </div>
        </div>
      </div>
    </div>
    </div>

    <div class="mb-6">
      <div class="info-card flex items-start w-343 tablet:w-720 laptop:w-912 py-5 pl-5 pr-6">
        <i class="fak fa-talos-information text-6 text-info-200 mr-4 mt-1"></i>
        <p class="text-3 text-dark">Once you’ve submitted this form, {{company}} will contact your referee via the email address entered above and ask them to supply a reference on your behalf. You don’t have to do anything further. You can keep track of when the referee reviews and submits their reference via the previous page.</p>
      </div>
    </div>
    <div class="flex justify-end w-343 tablet:w-720 laptop:w-912 pt-2">
      <div class="flex flex-col">
        <button class="rounded primary text-light text-4 px-10 py-4 h-52 w-343 tablet:w-220" (click)="onClickSaveButton()" [disabled]="isEditForm && !isFormTouched">Submit
          <i class="fak fa-talos-arrow-right text-5 pl-2" *ngIf="!isSaving"></i>
          <div class="spinner size-5 ml-2" *ngIf="isSaving"></div>
        </button>
        <div *ngIf="this.showValidation && form.status === 'INVALID'" class="text-error-500 text-2 mt-2 self-end">
          Your form contains errors
        </div>
      </div>
    </div>
    <div class="py-2 flex">
      <div class="flex items-center">
        <div>
          <div style="left: -168px;">
            <div class="flex w-343 tablet:w-720 laptop:w-912 items-center content-center self-center">
              <div class="divider w-343 tablet:w-720 laptop:w-912 my-6"></div>
            </div>
            <div>
              <p class="text-3 text-neutral-500">By submitting these details you are agreeing that you’ve read our <a href="/privacy-policy/" class="text-info-200 text-3" target="_blank">Privacy Policy</a> and confirming that we are able to store these details to process this reference check.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
